<template  >
    <v-layout column fill-height="">
    
        <not-toolbar-sub :not="not"/> 
    
         <!-- //access page -->
        <not-access-deny-page 
            v-if="!accessPage"
            :not="not"
            :notShow="true"/> 
        <!-- //page -->
    
        <v-layout column fill-height v-else>
            <not-page-spinner 
                :notShow="true" 
                :not="not"
                v-if="!page_show"/> 
            <div  v-else class="ma-10 "> 
                <v-card v-if="accessSMS('read')"> 
                    <mbs-item-manager
                        :table_title="MBS.actions.TEXT_UP(DATA.ITEMS.SMS_REPORTS.names)"
                        :top_label="false"
                        :name_items="DATA.ITEMS.WHATSAPP_REPORTS.names"
                        :name_item="DATA.ITEMS.WHATSAPP_REPORTS.name"
                        :value_items="DATA.ITEMS.WHATSAPP_REPORTS.values"
                        :value_item="DATA.ITEMS.WHATSAPP_REPORTS.value"  
                        :table_tabs="tableTabs"
                        :header_items="HEADER_ITEMS" 
                        :data_items="SMSReportsData"   
                        :is_joined="true"    
                        :table_actions="table_actions" 
                        @SELECT_TABLE_ACTION="TABLE_ACTION"
                        @SELECT_ITEM_ACTION="ITEM_ACTION"
                    />
                </v-card>
                <div v-else>
                    <v-layout  justify-center="" align-center="" class=" primary lighten-4 pa-9 ">
                        <v-icon size="50" color="primary">mdi-shield-account</v-icon>
                        <div>You do not have permission to read SMS.</div> 
                    </v-layout> 
                </div> 
                <br>
            </div>
    
        </v-layout>
    
        <!-- edit -->
        <v-dialog v-model="dialog_view_response" persistent max-width="800px"> 
            <v-card>
                <v-card-title class="primary white--text" dark>
                    <span class="headline">REPORT DETAILS</span>
                    <v-spacer></v-spacer> 
                    <v-btn @click="dialog_view_response = false" icon="" dark="" ><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text> 
                    <v-layout row wrap class="pa-5">
                         
                        <v-flex xs12 md6 > 
                            <strong>REPORTER NAME</strong>: {{input.reporter_name}}
                        </v-flex> 
                        <v-flex xs12 md6  > 
                            <strong>REPORTER PHONE:</strong> {{input.reporter?input.reporter.phone_number:"?:"}}
                        </v-flex> 
                        <v-flex xs12 md6  > 
                            <strong>REPORTER EMAIL:</strong> {{input.reporter?input.reporter.email:"?:"}}
                        </v-flex>  
                        <v-flex xs12 md6  > 
                            <strong>REPORTER GENDER:</strong> {{input.reporter?input.reporter.gender:"?:"}}
                        </v-flex> 
                        <v-flex xs12 class="py-2">
                            <v-divider></v-divider>  
                        </v-flex>
                        
                         
                        <v-flex xs12 md6 > 
                            <div>ANSWER: <strong>{{input.question_answer_only}}</strong></div>
                            <div>EXPLANATION: <strong>{{input.question_answer_explanation}}</strong></div> 
                            <div>RESPONSE: <strong>{{input.question_answer}}</strong></div> 
                        </v-flex>  
                        
                        <v-flex xs12 class="py-2">
                            <v-divider></v-divider>  
                        </v-flex>
                        <v-flex xs12 md4 > 
                            SUBMITTED DATE:  <strong>{{input.created_at}}</strong>
                        </v-flex> 
                        <v-flex xs12 md4 > 
                            REGION:  <strong>{{input.region_name}}</strong>
                        </v-flex>
                        <v-flex xs12 md4 > 
                            DISTRICT: <strong>{{input.district_name}}</strong>
                        </v-flex>  
                        <v-flex xs12 md4 > 
                            CONSTITUENCY: <strong>{{input.constituency_name}}</strong>
                        </v-flex>
                        <v-flex xs12 md4 > 
                            WARD: <strong>{{input.ward_name}}</strong>
                        </v-flex>  
                        <v-flex xs12 md4 > 
                            CENTRE: <strong>{{input.centre_name}}</strong>
                        </v-flex> 
                        
                    </v-layout>
                    <v-layout>
                        <v-spacer></v-spacer>
                        <v-btn @click="dialog_view_response = false" color="primary">OK</v-btn>
                    </v-layout>
                </v-card-text> 
          </v-card>
        </v-dialog>
    
    </v-layout>
    </template>
    
<script> 
    import DATA from '../../../plugins/DATA'
    import {mapState} from "vuex"
    let PAGE_NAME = 'SMS'
    let ACTION_TIME = 100
    export default{
        name: PAGE_NAME,
        props:['not'],  
        data: () => ({ 
            page_show: false, 
            page_show_response: false,

            menuSMS:false, 
            dialog_view_response:false,
                
            inputCode:null,
            input:{}, 
            HEADER_ITEMS:[  
                {id:1,name:"Geneal",title:true},
                {id:0,name:"No.",value:"no",show:true},
                {id:0,name:"date",value:"sent_at_",show:true},
                {id:0,name:"key",value:"key",show:false},
                {id:0,name:"From",value:'from',show:true},  
                {id:0,name:"Message",value:'message',show:true},  
                {id:0,name:"secret",value:"region_name",show:false}, 
                 
                // {id:0,name:"ee",value:'question_answer',show:true},
                {id:0,name:"Device",show:false}, 
                {id:0,name:"action",align:"right",show:true,item:[ 
                    {name:"Report Details",action:"detail_report",icon:"mdi-information-outline",show_if:item=>true}, 
                    {name:"Flag View Report",action:"view_report",icon:"mdi-eye"},  
                    {name:"Archive Report",action:"archive_item",icon:"mdi-delete"},   
                ]},  
            ],  
            DATA:DATA, 

            
            table_actions:[ 
                //{type:"btn",action:"add_invoice",color:"secondary", outlined:false,  text:"Add Received Invoice/Bill"},  
                // {type:"btn",action:"manage_invoices",color:"secondary", outlined:false,  text:"Manage Invoice/Bill "}, 
                {type:"action",icon:"mdi-microsoft-excel",action:"export_excel",color:"secondary", outlined:false,  text:"Export to Excel"}, 
            ],
                
        }),  
        created(){
                this.EventBus.$on('notYesDialog', this.notYesDialog); 
        },
        mounted() {   
            this.pageLoad(1000)  
        },
        computed:{ 
            accessSMS(){
                return permission=>{
                    if (permission === "read") {
                        return this.not.ACCESS_READ("responses") 
                    }else if (permission === "write") {
                        return this.not.ACCESS_WRITE("responses") 
                    }else if (permission === "edit") {
                        return this.not.ACCESS_EDIT("responses") 
                    }else if (permission === "delete") {
                        return this.not.ACCESS_DELETE("responses") 
                    }else{
                        return false
                    }
                }
            },
            accessPage(){
                return this.not.ACCESS_PAGE(this.$route.name)
            },
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
            }),
            ...mapState({
                SMSReports: state=> state.items[(DATA.ITEMS.SMS_REPORTS.values).toUpperCase()],
                JoinedSMSReports: state=> state.join[(DATA.ITEMS.SMS_REPORTS.values).toUpperCase()]
            }),  
            SMSReportsData(){ 
                console.log(this.JoinedSMSReports,'this.JoinedSMSReports....');
                return this.JoinedSMSReports?this.JoinedSMSReports:this.SMSReports
            },

            sms(){  
                let sms = this.$store.getters.getSMS
                if(!sms){return null}
                // return sms.filter(sm=>{
                //     return sm.user_key == this.ud.uid
                // })
                
                return sms 
            },
            JOINED_SMS(){ 
                let sms = this.sms  
                if(!sms){return null}
                let joinedquestionSMS = this.not.JOIN_SMS(sms)
                return joinedquestionSMS
            },

            tableTabs(){ 
                return [
                    {name:"New Reports",show_if:item=>!item.viewed,indicator:{
                        color:"blue",
                        value:items=>{
                            if(!items){return null}
                            let filtered = items.filter(item=>!item.viewed)
                            return this.MBS.actions.SIZE(filtered)
                        }
                    }},
                    {name:"Viewed Reports",show_if:item=>item.viewed,indicator:{
                        color:"accent",
                        value:items=>{
                            if(!items){return null}
                            let filtered = items.filter(item=>item.viewed)
                            return this.MBS.actions.SIZE(filtered)
                        }
                    }},
                    {name:"Submitted Reports",show_if:item=>item.submitted,indicator:{
                        color:"green",
                        value:items=>{
                            if(!items){return null}
                            let filtered = items.filter(item=>item.submitted)
                            return this.MBS.actions.SIZE(filtered)
                        }
                    }},
                ]
            },
            tab_reports(){
                let tab = this.tab
                let data = null
                if (tab===0) {
                    data = this.new_sms
                }else if (tab===1) {
                    data = this.viewed_sms
                }else if (tab===2) {
                    data = this.submitted_sms
                } 
                return data
            },
    
            all_sms(){
                // let sms = this.JOINED_SMS  
                let sms = this.SMSReportsData  
                return sms
            }, 
            new_sms(){
                let all_sms = this.all_sms
                if(!all_sms){return null}
                let viewed_sms = all_sms.filter(sm=>{   
                    if (sm.submitted===true) {return false}
                    if (sm.viewed===true) {return false}
                    return true
                })
                return viewed_sms
            }, 
            viewed_sms(){
                let all_sms = this.all_sms
                if(!all_sms){return null}
                let viewed_sms = all_sms.filter(sm=>{   
                    if (sm.submitted===true) {return false}
                    if (!this.us) {return false}
                    return sm.viewed_uid == this.us.uid
                })
                return viewed_sms
            }, 
            submitted_sms(){
                let all_sms = this.all_sms
                if(!all_sms){return null}
                let submitted_sms = all_sms.filter(sm=>{   
                    if (!this.us) {return false}
                    return sm.submitted_uid == this.us.uid
                })
                return submitted_sms
            },  

            show_action_viewed(){
                let show = true
                let tab = this.tab 
                if (tab===1) {
                    show = false
                } 
                if (tab===2) {
                    show = false
                } 
                return show
            }, 
            show_action_submitted(){
                let show = true
                let tab = this.tab 
                if (tab===0) {
                    show = false
                } 
                if (tab===2) {
                    show = false
                } 
                return show
            }, 
            
        },
        //------------methods---------------
        methods: { 
            TABLE_ACTION(action,item){
                try {
                    let route = this.route
                    let fullPath = route?route.fullPath:null 
                    if (action == "manage_invoices") {
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/quotations&invoices/",true))
                    } if (action == "manage_invoices") {
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/quotations&invoices/",true))
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TABLE_ACTION',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            ITEM_ACTION(action,item){
                try {
                    if (action == "detail_report") {  
                        this.viewSMSInfo(item)
                    }else if (action == "view_report") {
                        this.viewSMS(item)
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ITEM_ACTION',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            clicked(){ 
            },
            notYesDialog(action){
                if (action) {  
                    if (action.code ===PAGE_NAME+'=FLAG-SMS') { 
                        if (this.input.check) {  
                            this.input.check = false 
                            this.not.notDialogP(true,false,'Saving...')
                            setTimeout(() => {  
                                this.input.loading = true  
                                this.$store.dispatch("fi_update",{
                                    action:"SMS",
                                    path:DATA.PATHS.sms_reports+action.details.key+"/",
                                    data:action.details,
                                    us:this.us
                                }) 
                            }, ACTION_TIME);   
                        } 
                    } 
                    if (action.code ===PAGE_NAME+'=ADD-SMS-SUCCESS') {
                        this.dialog_add_report = false
                    }
                    if (action.code ===PAGE_NAME+'=EDIT-SMS-SUCCESS') {
                        this.dialog_view_response = false
                    }


                    if (action.code ===PAGE_NAME+'=CONFIRM-DELETE-SMS') {
                        if (this.input.check) {  
                            setTimeout(() => { 
                                this.not.notDialogCp(true,true,"CONFIRM","Enter your password to confirm deleting this SMS.","CANCEL","CONFIRM",{
                                    ...action,
                                    code:PAGE_NAME+"=DELETE-SMS",
                                }) 
                            }, ACTION_TIME);
                        }  
                    } 
                    if (action.code ===PAGE_NAME+"=CONFIRM-DELETE-ALL-SMSES") {
                        if (this.input.check) {  
                            setTimeout(() => {
                                this.not.notDialogCp(true,true,"CONFIRM","Enter your password to confirm deleting ALL SMSes. This action can not be reversed.","CANCEL","CONFIRM",{
                                    ...action,
                                    code:PAGE_NAME+"=DELETE-ALL-SMSES",
                                })  
                            }, ACTION_TIME);
                        }   
                    } 
                    
                    if (action.code ===PAGE_NAME+'=DELETE-SMS') {
                        if (this.input.check) {  
                            this.input.check = false  
                            setTimeout(() => { 
                                this.input.check = false
                                let password = action.password
                                if (password!==this.ud.password) {
                                    this.not.notDialog(true,false,"ERROR","Wrong password entered.","OK")
                                } else {
                                    this.$store.dispatch("fi_delete",{
                                        action:"SMS",
                                        path:"SMS/MS2021/"+action.sms.key+"/"
                                    }) 
                                }
                            }, ACTION_TIME);   
                        }  
                    } 
                    if (action.code ===PAGE_NAME+'=DELETE-ALL-SMSES') {
                        if (this.input.check) {  
                            this.input.check = false 
                            setTimeout(() => {
                                this.input.check = false
                                let password = action.password
                                if (password!==this.ud.password) {
                                    this.not.notDialog(true,false,"ERROR","Wrong password entered.","OK")
                                } else {
                                    this.$store.dispatch("fi_delete",{
                                        action:"SMS",
                                        path:"SMS/MS2021/" 
                                    }) 
                                }
                            }, ACTION_TIME);   
                        }     
                    }     
                } 
            }, 
            viewSMSInfo(response){
                this.inputCode = null
                this.input = {
                    ...response
                }  
                this.dialog_view_response = true
            },
            viewSMS(item){ 
                this.input={}
                this.input.check = true 
                    
                this.not.notDialog(true,true,"FLAG VIEWED SMS",'Are you sure you want to flag this SMS as viewed SMS?','CANCEL',"FLAG",{
                    code:PAGE_NAME+"=FLAG-SMS",
                    details:{
                        key:item.key,
                        viewed:true,
                        viewed_uid:this.us?this.us.uid:null
                    }
                }) 
                    
                
            }, 
            submitSMS(sms){ 
                this.input={}
                this.input.check = true 
                let key = sms.key
                this.not.notDialog(true,true,"FLAG SUBMITTED SMS",'Are you sure you want to flag this SMS as submitted SMS?','CANCEL',"FLAG",{
                    code:PAGE_NAME+"=FLAG-SMS",
                    details:{
                        ...this.input,
                        ...oldSMS,
                        submitted:true,
                        submitted_uid:this.us?this.us.uid:null
                    }
                })  
                // let oldSMS = this.$store.getters.getSMSByKey(key)
                // if (oldSMS) {
                // } else {
                //     this.not.notDialog(true,true,null,'ERROR','OK') 
                // }
            }, 
            deleteSMS(sms){
                let ud = this.ud
                let permission = true
                if (permission) { 
                    this.input.check = true 
                    this.not.notDialog(true,true,"DELETE SMS",'Are you sure you want to delete this SMS?','CANCEL',"SMS",{
                        code:PAGE_NAME+"=CONFIRM-DELETE-SMS",
                        sms:sms
                    })  
                    
                } 
            }, 
            deleteAllResponse(){
                let ud = this.ud
                let permission = true
                if (permission) { 
                    this.input.check = true
                    this.not.notDialog(true,true,"DELETE ALL SMSES",'Are you sure you want to delete ALL uploaded SMSes?','CANCEL',"DELETE",{
                        code:PAGE_NAME+"=CONFIRM-DELETE-ALL-SMSES",
                    })   
                } 
            },

            //Heades
            headers(type){
                let hds = null
                if (type === 'report') {
                    hds = this.xHeader_sms
                }else if (type === 'excel'){
                    hds = this.xHeader_sms2
                } 
                let headers = this.not.TABLE_HEADERS(hds) 
                return headers
            },  
            pageLoad(t){
                if (!t) {
                    t=400
                }
                setTimeout(()=>{
                    let us = this.loggedUser 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses
                    //this.page_show = false 

                    //Check proccess 
                    if (ps) {
                        let logging = ps.find(process=>{
                            return process.name == 'logging'
                        })
                        let getting = ps.find(process=>{
                            return process.name == 'getting/sms'
                        }) 
                        let updating = ps.find(process=>{
                            return process.name == "updating/sms" 
                        })  
                        let deleting = ps.find(process=>{
                            return process.name == 'deleting/sms'
                        })  

                        if (logging) {
                            this.page_show =false
                            this.not.notDialogP(true,true,'Logging...')
                        }else{ 
                            this.page_show = this.not.ACCESS_PAGE(this.$route.name)
                        }

                        if (getting) {
                            this.page_show_response =false
                            this.not.notDialogP(true,false,'Loading...')
                        }else{ 
                            this.page_show_response =true
                        }

                        
                            
                        if (updating) { 
                            this.not.notDialogP(true,false,'Saving...')
                            this.input.loading = true
                        }else{ 
                        }   
                        if (deleting) {
                            this.not.notDialogP(true,false,'Deleting...') 
                        }else{ 
                        }  

                        

                        //IF ALL DONE
                        if (ps.length===0) { 
                            this.page_show = this.not.ACCESS_PAGE(this.$route.name)
                            this.not.notDialogP(false)
                        }
                    }else{
                        this.page_show = this.not.ACCESS_PAGE(this.$route.name)
                        this.not.notDialogP(false)
                    }

                        


                        if (res.res==='updating/SMS/successful') { 
                        this.not.notDialog(true,true,'Successful','SMS successfully edited.','','OK',{code:PAGE_NAME+'=FLAG-SMS-SUCCESS'})
                        this.input.loading = false
                        this.dialog_view_response = false
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                    }else if (res.res==='updating/SMS/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while editing the SMS. Make sure your password is correct or contact admin.','','OK',{code:PAGE_NAME+'=FLAG-SMS-ERROR'})
                        this.input.loading = false
                        this.dialog_view_response = false
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    } 

                        
                    if (res.res==='deleting/SMS/successful') { 
                        this.not.notDialog(true,true,'Successful','SMS successfully deleted.','','OK',{code:PAGE_NAME+'=DELETE-SMS-SUCCESS'}) 
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                    }else if (res.res==='deleting/SMS/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while deleting the SMS. Make sure your password is correct or contact admin.','','OK',{code:PAGE_NAME+'=DELETE-SMS-ERROR'}) 
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    } 

                    
    
                },t)
            }
        }, 
        watch: {
            us(v){
                
            },
            loading(value){
                this.pageLoad(1)
            },
            processes(value){
                this.pageLoad(1)
            },
            responses(value){
                this.pageLoad(1) 
            } 
        },
    } 
    
</script>
     
    